import { FC } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import {
  SaveButton,
  SimpleForm,
  Toolbar,
  useRecordContext,
} from "react-admin";
import {
  ProductAdvancedInputs,
  ProductBasicsInputs,
  ProductMediaInputs,
} from "./inputs";
import { TProduct } from "@/api";

const FormToolbar = () => {
  const isEdit = !!useRecordContext();
  return (
    <Toolbar
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 2,
        backdropFilter: "blur(6px)",
      }}
    >
      <SaveButton alwaysEnable={isEdit} />
    </Toolbar>
  );
};

export const ProductForm: FC = () => {
  const product = useRecordContext<TProduct>();

  return (
    <SimpleForm
      mode="onBlur"
      record={product}
      toolbar={<FormToolbar />}
      warnWhenUnsavedChanges
    >
      <FormContent />
    </SimpleForm>
  );
};

const FormContent = () => {
  const groupDeps = {
    options: [],
    type: undefined,
    supplierId: undefined,
    categoryId: undefined,
  } as any;

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Section title="Identidad" defaultExpanded>
        <Box sx={{ pt: 1 }}>
          <ProductBasicsInputs groupDeps={groupDeps} />
        </Box>
      </Section>

      <Section title="Imágenes y descripción larga" defaultExpanded>
        <Box sx={{ pt: 1 }}>
          <ProductMediaInputs groupDeps={groupDeps} />
        </Box>
      </Section>

      <Section title="Avanzado (precio, dimensiones, estado)">
        <Box sx={{ pt: 1 }}>
          <ProductAdvancedInputs groupDeps={groupDeps} />
        </Box>
      </Section>
    </Stack>
  );
};

const Section = ({
  title,
  defaultExpanded,
  children,
}: {
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}) => (
  <Accordion
    defaultExpanded={defaultExpanded}
    disableGutters
    sx={{
      "&:before": { display: "none" },
      boxShadow: "none",
      border: 1,
      borderColor: "divider",
      borderRadius: 1,
      "&.Mui-expanded": { my: 0 },
    }}
  >
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
);

